<template>
  <div>
    <b-card>
      <b-spinner
        v-if="initialLoader"
        small
        label="Small Spinner"
      />

      <b-alert
        variant="danger"
        :show="errorMessage ? true : false"
        class="mb-0"
      >
        <div class="alert-body">
          <p>
            {{ errorMessage }}
          </p>
        </div>
      </b-alert>

      <div v-if="!initialLoader && !errorMessage">
        <div class="d-flex justify-content-between align-items-center">
          <span v-b-toggle.attention-required-list>
            <b-badge
              pill
              :variant="attentionRequiredInvoice.length > 0 ? 'danger' : 'primary'"
            >
              {{ attentionRequiredInvoice.length }}
            </b-badge>
            Attention Required Invoice(s)
          </span>
          <b-button
            :disabled="refreshLoader"
            variant="text"
            size="sm"
            class="p-0"
            @click.prevent="getData({isRefresh: true})"
          >
            <b-spinner
              v-if="refreshLoader"
              small
              label="Small Spinner"
            />
            <feather-icon
              v-else
              icon="RotateCcwIcon"
              size="16"
            />
          </b-button>
        </div>
        <b-collapse
          id="attention-required-list"
          class="mt-2"
        >
          <div class="attention-required-list">
            <span
              v-for="(invoice, index) in attentionRequiredInvoice"
              :key="index"
              class="clickable-invoice mr-1"
              @click="showInvoiceDetails(invoice)"
            >
              {{ invoice }}<span v-if="index < attentionRequiredInvoice.length - 1">, </span>
            </span>
          </div>
        </b-collapse>
      </div>
    </b-card>

    <InvoiceDetailsModal
      :show="showModal"
      :log-details="selectedLogDetails"
      @resolved="getData({ isRefresh: true })"
      @close="showModal = false"
    />

  </div>
</template>

<script>
import {
  BCard, BSpinner, BAlert, BCollapse, VBToggle, BBadge, BButton,
} from 'bootstrap-vue'
import axios from 'axios'
import InvoiceDetailsModal from './InvoiceDetailsModal.vue'

export default {
  directives: {
    'b-toggle': VBToggle,
  },
  components: {
    BCard,
    BSpinner,
    BAlert,
    BCollapse,
    BBadge,
    BButton,
    InvoiceDetailsModal,
  },
  props: {
    needRefresh: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      initialLoader: false,
      errorMessage: null,
      attentionRequiredInvoice: [],
      invoicesData: [], // Store the full response data
      refreshLoader: false,
      showModal: false,
      selectedLogDetails: null,
    }
  },
  watch: {
    needRefresh(newVal) {
      if (newVal) {
        this.getData({ isRefresh: true })
      }
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData(options) {
      const opts = options || {}
      const isRefresh = opts.isRefresh || false

      if (isRefresh) {
        this.refreshLoader = true
      } else {
        this.initialLoader = true
      }

      axios
        .get('failed_po_mails')
        .then(res => {
          this.invoicesData = res.data // Save the full response data
          this.attentionRequiredInvoice = res.data.map(item => item.invoice_number)
          this.errorMessage = null
          this.initialLoader = false
          this.refreshLoader = false
        })
        .catch(error => {
          this.errorMessage = (error && error.response && error.response.data && error.response.data.error) || 'Error fetching attention required Invoice'
          this.initialLoader = false
          this.refreshLoader = false
        })
    },
    showInvoiceDetails(invoiceNumber) {
      // Find the invoice details from saved data using a forEach approach
      let logData = null
      this.invoicesData.forEach(item => {
        if (item.invoice_number === invoiceNumber) {
          logData = item
        }
      })

      if (logData) {
        this.selectedLogDetails = logData
        this.showModal = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.attention-required-list {
  max-height: 100px;
  overflow-y: auto;
  overflow-x: hidden;
}

.clickable-invoice {
  color: #7367f0;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

</style>
